<template>
    <div v-if="locale === 'zh-CN'">
        <ZH />
    </div>
    <div v-else>
        <EN />
    </div>
</template>

<script setup>
import { parseQuery } from '@osgfe/tools';
import { ref } from 'vue';
import EN from './components/EN';
import ZH from './components/ZH';

const query = parseQuery();
const locale = ref(query.locale || 'en');
</script>
